module.exports = __webpack_public_path__ + "img/icon-market-microchip.2b8b7927.png";